import { ReactElement, useRef, useCallback } from 'react';

import { FormHandles } from '@unform/core';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button, GoBackButton } from '~/components';
import { useLoading } from '~/hooks/loading';
import { IUserCadasterRequiredForm } from '~/models/User';
import ProfessionalService from '~/services/Professional';
import { handleYupValidationError, formatDate } from '~/utils';
import { UserSchema } from '~/utils/schemas/UserSchema';

import EditUserForm from '../EditUserForm';

import * as S from './styles';

interface IEditUserParamsProps {
  id: string;
}

function EditUser(): ReactElement {
  const { setLoading } = useLoading();

  const router = useHistory();
  const formRef = useRef<FormHandles>(null);
  const { id } = useParams<IEditUserParamsProps>();

  const handleCancel = useCallback(() => {
    router.goBack();
  }, [router]);

  const handleEditUserSubmit = useCallback(
    async (data: IUserCadasterRequiredForm) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});
        let formatedDate = '';

        if (data.birth_date) {
          formatedDate = formatDate(data.birth_date);
          const isValid = new Date(formatedDate).toString() !== 'Invalid Date';

          if (!isValid) throw new Error('Data de nascimento inválida');
        }
        await UserSchema.validate({ ...data, birth_date: formatedDate });

        const result = await ProfessionalService.editUser(id, data);
        if (result.status === 200) {
          toast.success('Usuário editado com sucesso!');
          router.goBack();
        } else {
          toast.error('Ocorreu um problema ao editar o usuário!');
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleYupValidationError(formRef, error);
      }
    },
    [router],
  );

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.EditUserHeader>
          <S.EditUserTitle>Editar Treinador</S.EditUserTitle>
        </S.EditUserHeader>
        <EditUserForm
          handleSubmit={handleEditUserSubmit}
          formName="edit-user"
          formRef={formRef}
          userId={id}
        />
        <S.EditUserFooter>
          <Button
            form="edit-user"
            type="submit"
            textContent="Salvar"
            variant="black"
            size="small"
            extraStyles={{
              maxWidth: '200px',
            }}
          />
          <Button
            type="button"
            onClick={handleCancel}
            textContent="Cancelar"
            variant="red"
            size="small"
            extraStyles={{
              maxWidth: '200px',
            }}
          />
        </S.EditUserFooter>
      </S.Container>
    </>
  );
}

export default EditUser;
